import React from 'react';
import SchoolProgram from 'views/SchoolProgram'

const SchoolProgrampage = () => {
  return <SchoolProgram />;
};

export default SchoolProgrampage;